function deferFilterjQuery() {
    if (window.jQuery) {
        var $ = window.jQuery;
        $(function(){
          // On load/reload
          var pt_on_load = function() {
            // Accordion
            
              
            

            // Search
            $('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

            // Drop downs
            var moveClearButton = function () {
              $('.pt-display-dropdown').each(function( index ) {
                if (window.innerWidth > 768) {
                  if ($(this).find('.filter-clear').length > 0) {
                    $(this).find('.scroll-content ul').after($(this).find('.filter-clear'));
                  }
                } else {
                  if ($(this).find('.filter-clear').length > 0) {
                    $(this).find('.menu-trigger').after($(this).find('.filter-clear'));
                  }
                }
              });
            };

            moveClearButton();

            $( window ).resize(function() {
              moveClearButton();
            });

            $('.pt-display-dropdown:not(.filter-group-not-shown) .scroll-content').each(function( index ) {
              if($(this).parent().find('.menu-trigger').length === 0) {
                $(this).before('<div class="menu-trigger">'+ $(this).closest('.filter-group').find('h4').text() +'</div>');

                if($(this).find('li.selected').length && !$(this).parent().hasClass('filter-group-sort-orders')) {
                  var selected = $.map(
                    $(this).find('li.selected a'),
                    function(element){
                      return {
                        text: $(element).text(),
                        link: $(element).attr('href')
                      };
                    }
                  );

                  $('.selected-filters-container').addClass('active');
                  selected.forEach(item => {
                    $('.selected-filters').append('<div class="filter">' + item.text +'<a href="' + item.link +'">✕</a></div>');
                  })
                }
              }
            });

            //Sticky Mode
            
              
                $(window).scroll(function () {
                  var windowTop = $(window).scrollTop();
                  var stickyTop = $('.collection-hero').height() + $('.site-header').height();
                  
                  if (windowTop >= stickyTop && $('.site-header').hasClass('is-sticky')) {
                    $('.filter-menu-container').addClass('sticky-filter');
                    $('.filter-menu-container').css('top', $('.site-header').height());
                    // 32 is margin-bottom applied on filter container
                    $('.template-collection').css('padding-top', $('.filter-menu-container').height() + 32);
                  } else {
                    $('.filter-menu-container').removeClass('sticky-filter');
                    $('.filter-menu-container').css('top', 'unset');
                    $('.template-collection').css('padding-top', '0');
                  }
                });
              
            

            // View more
            

            //Add selected class on filter click
            $('.filter-menu li a').on('click', function() {
              $(this).closest('li').toggleClass('selected');
            })

            //Update filter item title
            $('.filter-menu li a').attr('title', function() {
              return ($(this).closest('li').hasClass('selected') ? "Clear filter: " : "Add filter: ") + $(this).text();
            });

            // Handle nested filters
            var splitPath = function(url) {
              var splitUrl =  url.split('?')[0].split('#')[0].split('/');
              return splitUrl;
            }

            var getCollection = function(url) {
              var splitUrl = splitPath(url);
              return splitUrl[2];
            }

            var getTags = function(url) {
              var splitUrl = splitPath(url);
              return (splitUrl[3] || '').split('+');
            }

            var getCommonCollection = function(url_top, url_nested) {
              var collection_top = getCollection(url_top);
              var collection_nested = getCollection(url_nested);
              if (collection_top !== collection_nested) {
                return 'all';
              }
              return collection_top;
            }

            var getCommonTags = function(url_top, url_nested) {
              var tags_top = getTags(url_top);
              var tags_nested = getTags(url_nested);

              return tags_top.filter(function(n) {
                return tags_nested.indexOf(n) > -1;
              });
            }

            var getCommonUrl = function(url_top, url_nested) {
              var val = '/collections/' + getCommonCollection(url_top, url_nested) + '/' + getCommonTags(url_top, url_nested).join('+');

              var lastChar = val.slice(-1);
                    if (lastChar == '/') {
                    val = val.slice(0, -1);
                }

              return val;
            }

            var clearNestedParent = $('.pt-display-nested').prev().each(function() {
              var clearNested = $(this).next().find('a.filter-clear').attr('href');
              if (!clearNested) return;
              var clearLink = $(this).find('a.filter-clear');
              clearLink.attr('href', getCommonUrl(clearLink.attr('href'), clearNested))
              var filterLinks = $(this).find('li.selected .collection-name a').each(function() {
                $(this).attr('href', getCommonUrl($(this).attr('href'), clearNested))
              })
            })
          }

          pt_on_load();

          // Accordion
          
          $(document).on('click', '.filter-menu h4', function(e){
            $(this).closest('.filter-group').not('.has_group_selected, .refine-header, .pt-display-dropdown').toggleClass('pt-group-expanded');
            e.preventDefault();
          });
          

          // Search
          $(document).on('keyup', '.filter-group input.fm-search-box', function () {
            var value = this.value.toLowerCase();
            $(this).closest('.filter-group').find('li').each(function () {
              if ($(this).text().toLowerCase().search(value) > -1) {
                $(this).show(100);
              } else {
                $(this).hide(100);
              }
            });
          });

          // Drop downs
          $(document).on('click','.pt-display-dropdown .menu-trigger',function() {
            $(this).next('.scroll-content').css('top', $(this).position().top + $(this).height() + 10).css('left', $(this).position().left);
            $(this).next('.scroll-content').slideToggle('fast');
            $(this).parent().toggleClass('active');
          });

          // $(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function() {
          //   $(this).slideUp('fast');
          //   $(this).parent().toggleClass('active');
          // });

          // Apply button
          

          // Ajax
          
          $.getScript("//www.bluebella.com/cdn/shop/t/75/assets/jquery.pjax.js?v=138580039773092267901585232768").done(function(script, textStatus) {
            $body = $("body");
            $(document).pjax('#main .filter-group a, #main .pagination a', '#main', { fragment: '#main', timeout: 10000, scrollTo: false, push: true });
            $(document).on('pjax:start', function(){  $body.addClass("pt-ajax-loading"); $('#main').fadeTo('slow', 0.8); })
            $(document).on('pjax:end', function(){ $body.removeClass("pt-ajax-loading"); $('#main').fadeTo('fast', 1); pt_on_load(); ; });
          });
          
      });
    }
    else {
        setTimeout(function() { deferFilterjQuery() }, 50);
    }
}

deferFilterjQuery();
